"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InviteTokenSchema = exports.INVITE_TOKEN_PATTERN = void 0;
const zod_1 = require("zod");
/** Telegram allows up to 64 chars of [A-Za-z0-9_-] in a `start` payload; invite tokens use the same alphabet. */
exports.INVITE_TOKEN_PATTERN = /^[A-Za-z0-9_-]{1,64}$/;
exports.InviteTokenSchema = zod_1.z.string().regex(exports.INVITE_TOKEN_PATTERN);
//# sourceMappingURL=invite-token.js.map